import * as Joi from 'joi';
import { SendUniqueLinkEmailFormData } from '../../../../api-refactored/unique-link/usePostSendUniqueLinkEmail';
import { getJoiObject } from '../../../../utils/JoiUtils';

export type SendUniqueLinkEmailFormDataDisabledFields = {
  [P in keyof SendUniqueLinkEmailFormData]?: boolean;
};

const createUniqueLinkFormSchema = (disabledFields?: SendUniqueLinkEmailFormDataDisabledFields) =>
  Joi.object({
    isWaiveSubjectAdminFee: Joi.boolean().allow(null),
    isWaiveLateFee: Joi.boolean().allow(null),
    isOfflinePayment: Joi.boolean().allow(null),
    expiryDate: Joi.allow(null, ''),
    description: getJoiObject(
      Joi.string().required().max(200).messages({
        'string.required': 'Please enter a description for this unique link',
        'any.required': 'Please enter a description for this unique link',
        'string.max': 'Description should have a maximum length of 200 characters',
      }),
      disabledFields?.description
    ),
  });
export default createUniqueLinkFormSchema;
